import {BaSeBackendNoSignalPage} from "@base/react";

const NoSignalPage = () => {
  return (
    <BaSeBackendNoSignalPage
      button={{
        leftIcon: 'device/phone-line',
        onClick: () => {window.open("https://sacnacional.sebrae.com.br/",'_blank')},
        value: 'Fale conosco'
      }}
    />
  )
}

export default NoSignalPage
